import React, { useState } from "react";
import { Accordion, AccordionSummary, Grid, Link } from "@mui/material";
import TranslationSpecific from "./TranslationSpecific";
import styles from "../translations/Translation.module.scss";
import AddNewTranslation from "./AddNewTranslation";
import crStyles from "../customerReservation/crStyles";
import TranslationsClient from "./TranslationsClient";
import { LANCODES } from "../../common/Constants";
import { COLLAPSE_TRANSLATIONS } from "../../common/CollapseTranslations";

const TranslationTable = (props) => {
  const [showNewTranslation, setShowNewTranslation] = useState(false);
  const [showInput, setShowInput] = useState(true);
  const [isExpended] = useState(
    COLLAPSE_TRANSLATIONS.indexOf(props.translations.moduleKey) === -1
      ? true
      : false
  );

  const onClick = () => {
    setShowNewTranslation(true);
    setShowInput(false);
  };

  const cancelSpecificTranslation = () => {
    setShowNewTranslation(false);
    setShowInput(true);
  };

  const addSpecificTranslation = (updatedLanguage) => {
    props.hideOrShow(true);
    TranslationsClient.postAddTranslations(
      updatedLanguage,
      props.getMarketsForNewTranslations()
    )
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        setShowInput(true);
        setShowNewTranslation(false);
        props.hideOrShow(false);
        props.getTranslations(props.currentLan);
      });
  };

  return (
    <div>
      <br />
      <Accordion styles={crStyles.expansionPanel} defaultExpanded={isExpended}>
        <AccordionSummary style={crStyles.headerBar}>
          <div className={styles.moduleKey}>{props.translations.moduleKey}</div>

          <br />
        </AccordionSummary>
        <Grid container className={styles.translation_header}>
          <Grid item md={3} className={styles.lanHeader}>
            {props.t("Translations.key")}
          </Grid>
          <Grid item md={3} className={styles.lanHeader}>
            {LANCODES["en"]}
          </Grid>
          <Grid item md={3} className={styles.lanHeader}>
            {LANCODES[props.currentLan]}
          </Grid>
          <Grid item md={3} className={styles.lanHeader}>
            {props.t("Translations.action")}
          </Grid>
        </Grid>

        <div>
          {Object.keys(props.translations.languages).length !== 0
            ? Object.keys(props.translations.languages).map((lan) => {
                return (
                  <TranslationSpecific
                    {...props}
                    language={props.translations.languages[lan]}
                    moduleKey={props.translations.moduleKey}
                    key={props.translations.languages[lan].key}
                  />
                );
              })
            : null}
        </div>

        <div className={styles.translation_header}>
          <div
            style={{
              position: "relative",
              float: "left",
              paddingBottom: "15px",
            }}
          >
            {showInput ? (
              <Link
                className={styles.newTranslation}
                style={{ color: "#102b4e" }}
                variant="contained"
                onClick={onClick}
              >
                {props.t("Translations.addNewTrans")}
              </Link>
            ) : null}
          </div>
        </div>
        {showNewTranslation ? (
          <AddNewTranslation
            {...props}
            moduleKey={props.translations.moduleKey}
            cancelSpecificTranslation={cancelSpecificTranslation}
            addSpecificTranslation={addSpecificTranslation}
          />
        ) : null}
      </Accordion>
    </div>
  );
};

export default TranslationTable;
